var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"id":"setting-placeholder"}},[_c('div',{staticClass:"close-bar"},[_c('span',{staticClass:"bjy-close",on:{"click":_vm.close}},[_vm._v("X")])]),_c('div',{staticClass:"placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }